import type { IObjectViewModel } from '@/engine/app/interfaces';
import type { ViewEntity } from '@/engine/app/models/viewEntity/view.entity';
import type { ICommand } from '@/engine/app/modules/core/interfaces/Command';
import * as DT from '@/engine/PlanningAlgorithm/DataTypes';
import type { ViewsService } from '@/engine/app/Views.service';
import type * as THREE from 'three';
import type { PlanningAlgorithm } from '@/engine/PlanningAlgorithm/PlanningAlgorithm';
import {
  addCustomCommissurePointsViewModels,
  removeCustomCommissurePointsViewModels
} from '../CustomCommissurePointsHelpers';
import type { ITTVRObjectsAlgoHelper } from '@/surgeries/cardiac/TTVR/interfaces';

export class AddCommissureCommand implements ICommand {
  private readonly _targetView: ViewEntity;

  private readonly _viewModel: IObjectViewModel;

  private readonly _vector: THREE.Vector3;

  private readonly _vectorDescriptor: string;

  private readonly _viewsService: ViewsService;

  private readonly _planningAlgorithm: PlanningAlgorithm;

  private readonly _algoHelper: ITTVRObjectsAlgoHelper;

  public constructor(
    view: ViewEntity,
    vector: THREE.Vector3,
    vectorDescriptor: string,
    viewModel: IObjectViewModel,
    viewsService: ViewsService,
    planningAlgorithm: PlanningAlgorithm,
    algoHelper: ITTVRObjectsAlgoHelper
  ) {
    this._targetView = view;
    this._viewModel = viewModel;

    this._vector = vector;
    this._vectorDescriptor = vectorDescriptor;
    this._viewsService = viewsService;
    this._planningAlgorithm = planningAlgorithm;
    this._algoHelper = algoHelper;
  }

  public async execute(): Promise<boolean> {
    await this._algoHelper.addObjectAsync(this._viewModel.descriptor);

    await this._planningAlgorithm.setValueAsync(this._vectorDescriptor, new DT.Vector(this._vector));
    this._viewModel.setHighlighting(false);
    this._viewModel.setSelection(false);
    addCustomCommissurePointsViewModels(this._targetView, this._viewsService, this._viewModel);

    return true;
  }

  public async undo(): Promise<undefined> {
    removeCustomCommissurePointsViewModels(this._targetView, this._viewsService, this._viewModel);
    await this._algoHelper.deleteObjectAsync(this._viewModel.descriptor);
  }
}
